import React, { useEffect, useReducer, useState } from 'react';
import { Box, Spinner } from 'wt-ui';
import CalendarHeader from '../../components/CalendarHeader';
// import CalendarTable from '../../components/CalendarTable';
import MainTable from '../../components/MainTable';
import CalendarLegend from '../../components/CalendarLegend';

import reducer from './reducer';
import API from '../../services/API';

import FILTER_OPTIONS from '../../components/CalendarHeader/Options';

const Calendar = () => {
  const [loading, setloading] = useState(true);
  const [state, dispatch] = useReducer(reducer, {
    range: 'thisMonth',
    filters: FILTER_OPTIONS.map((x) => ({ name: x, selected: true })),
  });

  const loadCalendarEvents = async () => {
    setloading(true);
    const result = await API.getCalendarEvents({
      range: state.range,
      filters: state.filters,
    });
    dispatch({ type: 'setEvents', value: result });
    setloading(false);
  };

  useEffect(() => {
    loadCalendarEvents();
  }, [state.range]);

  if (loading) {
    return (
      <Box background="transparent" align="center">
        <Spinner primary />
      </Box>
    );
  }

  return (
    <Box background="transparent" gap="small">
      <CalendarHeader range={state.range} filters={state.filters} dispatch={dispatch} />

      <MainTable data={state.events} filters={state.filters} />

      <CalendarLegend />
    </Box>
  );
};
// <CalendarTable data={state.events} />

export default Calendar;
